module.exports = __webpack_public_path__ + "static/media/import.a54fe998.svg";